export class InitializeResponse {
  orderId?: number;
  authorizeResult?: AuthorizeResult;
}

export enum BankIdVerificationStatus {
  NotAuthenticated = 'NotAuthenticated',
  Authenticated = 'Authenticated',
  SsnIsSameAsCustomerSsn = 'SsnIsSameAsCustomerSsn',
  SsnIsDifferentFromCustomerSsn = 'SsnIsDifferentFromCustomerSsn',
  NotAnSsn = 'NotAnSsn',
  Unknown = 'Unknown',
}

export class BankIdVerification {
  id: string;
  verificationLinkCode: string;
  status: BankIdVerificationStatus;
  isSsnMatchingSsnInCreditCheck?: boolean = true;
  isAuthenticatedFromManny?: boolean;
}

export class AuthorizeResult {
  currentNoOfSubscriptions?: number;
  totalAllowedNoOfSubscriptions: number;
  noOfAdditionalSubscriptionsAllowed: number;
  currentNoOfFreemiumSubscriptions: number;
  creditCheckedEntity: CreditCheckedPerson;
  subscriptionAllowance: ProductAllowance;
  mbbSubscriptionAllowance: ProductAllowance;
  downPaymentAllowance: ProductAllowance;
  equipmentUpgrade: EquipmentUpgradeAllowance;
  approved: boolean;
  reason: string;
  reasonCode: string;
  tradeIn: TradeInAllowance;
}
export interface CreditCheckedPerson {
  firstName?: string;
  lastName?: string;
  address?: string;
  address2?: string;
  city?: string;
  zip?: string;
  birthDate?: Date;
}
export interface ProductAllowance {
  totalAllowedAmount: number;
  currentAmount: number;
  additionalAmountAllowed: number;
  approved: boolean;
  reason: string;
  reasonCode: string;
}

export interface EquipmentUpgradeAllowance {
  canBuyEquipmentUpgrade: boolean;
  creditApplicationApprovalProbability: CreditApplicationApprovalProbability;
  currentAmount: number;
  noOfSubsAvailableForEquipmentUpgrade: number;
  creditLimitAmount: number;
  hasSubAvailableForRedemption: boolean;
  existingCompatibleSubscriptions: ExistingCompatibleSubscriptions[];
  usedCredit?: number;
  availableCredit?: number;
  redemptionCreditDecision?: boolean;
}

export interface TradeInAllowance {
  canUseTradeIn: boolean;
  currentNumberOfActiveTradeIns: number;
  hasSubAvailableForTradeIn: boolean;
  numberOfTradeInsAvailableForUse: number;
}

export interface ExistingCompatibleSubscriptions {
  msisdn: string;
  agreementId?: number;
  quarantineEndDate?: Date;
}

export enum CreditApplicationApprovalProbability {
  Probably = 'Probably',
  ProbablyNot = 'ProbablyNot',
  Unknown = 'Unknown',
}

export type DownPaymentPayload = {
  customerId?: string;
  firstName: string;
  lastName: string;
  ssn: string;
};
